var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempalteIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 1.33333V4H1.33333V1.33333H14.6667ZM14.6667 0H1.33333C0.596672 0 0 0.596672 0 1.33333V4C0 4.35332 0.140834 4.6925 0.390827 4.94251C0.640819 5.19251 0.979989 5.33333 1.33333 5.33333H14.6667C15.02 5.33333 15.3592 5.1925 15.6092 4.94251C15.8592 4.69251 16 4.35334 16 4V1.33333C16 0.980011 15.8592 0.640832 15.6092 0.390827C15.3592 0.140821 15.02 0 14.6667 0Z",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.00008V14.6667H1.33333V8.00008H4ZM4 6.66675H1.33333C0.596672 6.66675 0 7.26342 0 8.00008V14.6667C0 15.0201 0.140834 15.3592 0.390827 15.6093C0.640819 15.8593 0.979989 16.0001 1.33333 16.0001H4C4.35332 16.0001 4.6925 15.8592 4.94251 15.6093C5.19251 15.3593 5.33333 15.0201 5.33333 14.6667V8.00008C5.33333 7.64676 5.1925 7.30758 4.94251 7.05757C4.69251 6.80757 4.35334 6.66675 4 6.66675Z",
    fill: "#172B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 8.00008V14.6667H8.00033V8.00008H14.667ZM14.667 6.66675H8.00033C7.26366 6.66675 6.66699 7.26342 6.66699 8.00008V14.6667C6.66699 15.0201 6.80783 15.3592 7.05782 15.6093C7.30781 15.8593 7.64698 16.0001 8.00033 16.0001H14.667C15.0203 16.0001 15.3595 15.8592 15.6095 15.6093C15.8595 15.3593 16.0003 15.0201 16.0003 14.6667V8.00008C16.0003 7.64676 15.8595 7.30758 15.6095 7.05757C15.3595 6.80757 15.0203 6.66675 14.667 6.66675Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempalteIc);
export default __webpack_public_path__ + "static/media/Tempalte_ic.4e18aa3410c4938a14ac8858250b9ecd.svg";
export { ForwardRef as ReactComponent };